// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreOrderDetailsState from "@store/Framework/Store/Store/Pages/OrderDetails/StoreOrderDetailsState";
import { TrackingInfoModel } from "@store/Framework/Types/TrackingInfoModel";
import { Draft } from "immer";

const initialState: StoreOrderDetailsState = {
    orderTracking: {},
};

const actions = {
    "Store/Pages/OrderDetails/GetTrackingInfo": (
        draft: Draft<StoreOrderDetailsState>,
        action: { trackingInfo: TrackingInfoModel },
    ) => {
        draft.orderTracking.trackingInfo = action.trackingInfo;
    },
    "Store/Pages/OrderDetails/SetTrackingInfoReady": (
        draft: Draft<StoreOrderDetailsState>,
        action: { ready: boolean },
    ) => {
        draft.orderTracking.ready = action.ready;
    },
    "Store/Pages/OrderDetails/SetNewEmailNotifications": (
        draft: Draft<StoreOrderDetailsState>,
        action: { newEmailNotificationsState: boolean },
    ) => {
        draft.orderTracking.newEmailNotificationsState = action.newEmailNotificationsState;
    },

    "Store/Pages/OrderDetails/ShippingNotificationCompleted": (
        draft: Draft<StoreOrderDetailsState>,
        action: { newEmailNotificationsState: boolean; newNotificationsEmail: string },
    ) => {
        draft.orderTracking.showNotificationSuccessMessage = true;
        draft.orderTracking.emailNotificationsState = action.newEmailNotificationsState;
        draft.orderTracking.notificationsEmail = action.newNotificationsEmail;
    },
    "Store/Pages/OrderDetails/ShippingNotificationFailed": (draft: Draft<StoreOrderDetailsState>) => {
        draft.orderTracking.showNotificationErrorMessage = true;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreOrderDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
